'use client';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/esm/extends";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { MessageActions } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatMessageUtilityClasses } from "./chatMessageClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatMessageActions');
const ChatMessageActionsStyled = styled('div', {
  name: 'MuiChatMessage',
  slot: 'Actions',
  overridesResolver: (_, styles) => styles.actions
})(({
  theme,
  ownerState
}) => _extends({
  gridArea: 'actions',
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(0.25),
  opacity: 0,
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.short
  }),
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none'
  },
  '.MuiChatMessage-root:hover &, .MuiChatMessage-root:focus-within &': {
    opacity: 1
  }
}, ownerState?.role === 'user' && {
  justifySelf: 'end'
}, {
  backgroundColor: (theme.vars || theme).palette.background.paper,
  borderRadius: theme.shape.borderRadius,
  boxShadow: (theme.vars || theme).shadows[1],
  padding: theme.spacing(0.25),
  '& .MuiIconButton-root': {
    padding: theme.spacing(0.5)
  },
  '& .MuiSvgIcon-root': {
    fontSize: theme.typography.pxToRem(16)
  }
}));
const ChatMessageActions = /*#__PURE__*/React.forwardRef(function ChatMessageActions(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatMessageActions'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatMessageUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(MessageActions, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      actions: slots?.actions ?? ChatMessageActionsStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      actions: _extends({
        className: clsx(classes.actions, className),
        sx
      }, slotProps?.actions)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatMessageActions.displayName = "ChatMessageActions";
process.env.NODE_ENV !== "production" ? ChatMessageActions.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatMessageActions };